import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { environmentAtom } from '@root/shared'
import { ApiError, apiRequest } from '@root/shared/api'
import { reatomRequest } from '@root/shared/lib'

export const uploadPngRequestAction = action(
  async (ctx, { dataUrl }: { dataUrl: string }) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesUploadTempImageCreate, [
        {
          image: dataUrl,
        },
      ]),
    )

    return pipe(
      result,
      // Crazy BE naming
      Result.map((it) => ({ imageUrl: it.imageFile })),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'uploadPngRequestAction',
)

export const reatomUploadPng = () => {
  return reatomRequest({
    execAction: uploadPngRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'reatomFileUpload',
    mapOutput: (ctx, result) => {
      const {
        assets: { tempImagesHost },
      } = ctx.get(environmentAtom)
      return `${tempImagesHost}/${result.imageUrl}`
    },
  })
}
